import type { BrainMetrics, BrainPolicy } from '../types'

type Props = { policy?: BrainPolicy; metrics?: BrainMetrics; loading: boolean }

export function BrainOverview({ policy, metrics, loading }: Props) {
  const cards = [
    { label: 'Decisões em 30 dias', value: metrics?.requests ?? 0 },
    { label: 'Produtos encontrados', value: (metrics?.matched ?? 0) + (metrics?.similar ?? 0) },
    { label: 'Buscas recuperadas', value: metrics?.recoveredResults ?? 0 },
    { label: 'Buscas sem resultado', value: metrics?.zeroResults ?? 0 },
    { label: 'Catálogo vazio', value: metrics?.catalogEmpty ?? 0 },
    { label: 'Conversão de checkout', value: `${(metrics?.conversionRate ?? 0).toFixed(1)}%` },
    { label: 'Latência média', value: `${Math.round(metrics?.averageLatencyMs ?? 0)} ms` },
    { label: 'Custo estimado', value: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(metrics?.estimatedCost ?? 0) },
  ]
  return <section className="brain-hero panel">
    <div className="brain-hero-copy">
      <span className="eyebrow">INTELIGÊNCIA ARTIFICIAL</span>
      <h1>Cérebro da MIA</h1>
      <div className="brain-status-row"><span className={policy?.enabled ? 'status-pill success' : 'status-pill neutral'}>{policy?.enabled ? 'Ativo' : 'Desativado'}</span><span>Texto {policy?.textEnabled ? 'ativo' : 'inativo'}</span><span>Áudio {policy?.audioEnabled ? 'ativo' : 'inativo'}</span><span>Imagem {policy?.imageEnabled ? 'ativa' : 'inativa'}</span></div>
    </div>
    <div className="brain-metric-grid" aria-busy={loading}>{cards.map((card) => <article className="brain-metric" key={card.label}><small>{card.label}</small><strong>{loading ? '—' : card.value}</strong></article>)}</div>
  </section>
}
